
import { defineComponent, PropType } from 'vue'

import { CodeCoverageT, CoverageSortT } from '~/types/reportTypes'
import { RepositoryCoverageReportItem } from '~/types/types'

export default defineComponent({
  name: 'CodeCoverageTable',
  components: {
    CodeCoverageSort: () => import('./CodeCoverageSort.vue'),
    CodeCoverageTableCell: () => import('./CodeCoverageTableCell.vue')
  },
  model: {
    prop: 'selectedSortFilter',
    event: 'sort-filter-updated'
  },
  data() {
    return {
      CodeCoverageT
    }
  },
  props: {
    selectedSortFilter: {
      type: String as PropType<CoverageSortT>,
      required: true
    },
    isWidget: {
      type: Boolean,
      default: false
    },
    linkedRows: {
      type: Boolean,
      default: false
    },
    repoCoverageList: {
      type: Array as PropType<Array<RepositoryCoverageReportItem>>,
      required: true
    }
  },
  computed: {
    activeSortFilter: {
      get() {
        return this.selectedSortFilter
      },
      set(val: CoverageSortT) {
        this.$emit('sort-filter-updated', val)
      }
    },
    bcvSortFilters() {
      return {
        [CoverageSortT.BCV_ASCENDING]: {
          label: this.isWidget ? 'BRANCH' : 'BRANCH COVERAGE',
          icon: 'arrow-up',
          name: CoverageSortT.BCV_ASCENDING
        },
        [CoverageSortT.BCV_DESCENDING]: {
          label: this.isWidget ? 'BRANCH' : 'BRANCH COVERAGE',
          icon: 'arrow-down',
          name: CoverageSortT.BCV_DESCENDING
        }
      }
    },
    lcvSortFilters() {
      return {
        [CoverageSortT.LCV_ASCENDING]: {
          label: this.isWidget ? 'LINE' : 'LINE COVERAGE',
          icon: 'arrow-up',
          name: CoverageSortT.LCV_ASCENDING
        },
        [CoverageSortT.LCV_DESCENDING]: {
          label: this.isWidget ? 'LINE' : 'LINE COVERAGE',
          icon: 'arrow-down',
          name: CoverageSortT.LCV_DESCENDING
        }
      }
    }
  },
  methods: {
    getFormattedRepoName(repoName: string) {
      return repoName.replace(/:/g, ' / ')
    }
  }
})
